import React, { useCallback } from "react";
import GradientLine from "./GradientLine";
import Line from "./Line";
import LightTheme from "../theme/LightTheme";

interface Props {
  label: string;
  index: number;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
}

const SegmentButton = ({
  label,
  index,
  activeIndex,
  setActiveIndex,
}: Props) => {
  const onClick = useCallback(() => {
    setActiveIndex(index);
  }, [index, setActiveIndex]);

  return (
    <div>
      <button
        type="button"
        className={activeIndex === index ? "active" : ""}
        onClick={onClick}
      >
        {label}
      </button>
      {activeIndex === index ? <GradientLine /> : <Line />}
      <style jsx>{`
        div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0 5px;
        }
        button {
          background: none;
          border: none;
          font-weight: normal;
          font-size: 1rem;
          color: ${LightTheme.font.secondary.color};
          cursor: pointer;
          white-space: nowrap;
        }
        .active {
          font-weight: bold;
          color: #343434;
        }
      `}</style>
    </div>
  );
};

export default SegmentButton;
